import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CreditCardFormWrapper from '../components/Common/CreditCardFormWrapper';
import ENV_VARS from '../utils/envVars';

const stripePromise = loadStripe(ENV_VARS.STRIPE_PUBLISHABLE_KEY);

class CreditCardForm extends Component {
  render() {
    const {
      toggle,
      showSubmissionError,
      showCancel,
      buttonText,
      buttonColClass,
      onSubmit,
      showName,
      showCoupon: maybeShowCoupon,
      signup,
      onCoupon,
      onClearCoupon,
    } = this.props;
    
    const showCoupon = maybeShowCoupon && (signup.membership.billingFrequency !== 'lifetime');

    return (
      <Elements
        stripe={stripePromise}
        fonts={[{ cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:400,500,600|Open+Sans:400,400i,600&display=swap' }]}
        options={{
          mode: signup.membership.billingFrequency === 'lifetime' ? 'payment' : 'subscription',
          amount: Math.floor(signup.membership.fullPrice * 100),
          currency: 'usd'
        }}
      >
        <CreditCardFormWrapper
          toggle={toggle}
          showSubmissionError={showSubmissionError}
          showCancel={showCancel}
          buttonText={buttonText}
          buttonColClass={buttonColClass}
          onSubmit={onSubmit}
          showName={showName}
          showCoupon={showCoupon}
          signup={signup}
          onCoupon={onCoupon}
          onClearCoupon={onClearCoupon}
        />
      </Elements>
    );
  }
}

CreditCardForm.propTypes = {
  toggle: PropTypes.func,
  showSubmissionError: PropTypes.func,
  showCancel: PropTypes.bool,
  showName: PropTypes.bool,
  showCoupon: PropTypes.bool,
  buttonText: PropTypes.string,
  buttonColClass: PropTypes.string,
  onSubmit: PropTypes.func,
  signup: PropTypes.instanceOf(Object),
  onCoupon: PropTypes.func,
  onClearCoupon: PropTypes.func,
};

export default CreditCardForm;
